import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@api/Auth/auth.service';
import { content_endpoint } from '@api/path-api';
import { AbstractApiService } from '@core/Interceptor/jsonrpc.abstract';
import { map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiGeneralService extends AbstractApiService<any> {



constructor(
 http: HttpClient,
 private auth: AuthService
//  private listener: ListenerService
) {
  super(http,'null');
 }


getDataFooter(){
  this.getAll({},content_endpoint.content+'footer').then(res=>{
    if(res){
      // this.data = res.data;
      // this.listener.footer.set(res.data);
    }
  })
}

getCity(provinceID:any) {

  var httpOptions = {
    headers: new HttpHeaders({
      Authorization: ``,
    }),
  };

  if(provinceID == ''){
    return this.http.get<any>(
      `${environment.apiUrl}/location-city`,
      httpOptions
    );
  }else{
    return this.http.get<any>(
      `${environment.apiUrl}/location-city?province=${provinceID}`,
      httpOptions
    );
  }

}

getKprBunga() {

  var httpOptions = {
    headers: new HttpHeaders({
      Authorization: ``,
    }),
  };

  return this.http.get<any>(
    `${environment.apiUrl}/kpr-bunga`,
    httpOptions
  );
}

downloadHasil2(hargaProperty:any, dpPayment:any, jangkaWaktu:any,angsuran:any, name:any,dpPersen:any, diskon:any, penempatanDana:any) {
  // console.log("Param : " + JSON.stringify(params.value))

  const body = {
    hargaProperty:hargaProperty,
    dpPayment:dpPayment,
    jangkaWaktu:jangkaWaktu,
    name:name,
    dpPersen:dpPersen,
    angsuran:angsuran,
    diskon:diskon,
    penempatanDana:penempatanDana
  }
  const httpOptions = {
    headers: new HttpHeaders({
      Authorization: `Bearer ${this.auth.token}`,
    }),
  };

  // return this.http.post<any>(
  //   `${environment.baseUrl}/api/simulasi-kpr`,
  //   body,
  //   httpOptions
  // );

  return this.http.post<any>(
    `${environment.apiUrl}/simulasi-kpr`,
    body,
    httpOptions
  );
}

getKPRExhibitorByFilter(hall:string, province:string, city:string, keyword:string, type:string) {

  var token = this.auth.token

  const httpOptions = {
    headers: new HttpHeaders({
       'Authorization': token != ''  ? `Bearer ${token}` : ''
    })
  };

  if(province != '' && city == ''){
    return this.http.get<any>(
      `${environment.apiUrl}/exhibitor-filter?hall=${hall}&province_id=${province}&keyword=${keyword}&type=${type}`, httpOptions
    );
  }else if (city != '' && province == ''){
    return this.http.get<any>(
      `${environment.apiUrl}/exhibitor-filter?hall=${hall}&city_id=${city}&keyword=${keyword}&type=${type}`, httpOptions
    );
  }else if(province == '' && city == ''){
    return this.http.get<any>(
      `${environment.apiUrl}/exhibitor-filter?hall=${hall}&keyword=${keyword}&type=${type}`, httpOptions
    );
  }else{
    return this.http.get<any>(
      `${environment.apiUrl}/exhibitor-filter?hall=${hall}&province_id=${province}&city_id=${city}&keyword=${keyword}&type=${type}`, httpOptions
    );
  }

}

getExhibitorByFilter(hall:string, province:string, city:string, keyword:string) {

  var token = this.auth.token

  const httpOptions = {
    headers: new HttpHeaders({
       'Authorization': token != ''  ? `Bearer ${token}` : ''
    })
  };
  return this.http.get<any>(
    `${environment.apiUrl}/exhibitor-filter?hall=${hall}&province_id=${province}&city_id=${city}&keyword=${keyword}`, httpOptions
  );

}

submitHubungiSaya(data:any, type:string){
  var token = this.auth.token;

  const httpOptions = {
    headers: new HttpHeaders({
      'Authorization': token != ''  ? `Bearer ${token}` : '',
      'Accept': 'application/json',
      // 'X-Localization': this.language
    })
  };

  return this.http.post<any>(
    `${environment.apiUrl}/contact-me?hall_type=${type}`,data,
    httpOptions
  );
}

saveFile(fileID:string){
  var token = this.auth.token;

  const httpOptions = {
    headers: new HttpHeaders({
      'Authorization': token != ''  ? `Bearer ${token}` : '',
      'Accept': 'application/json',
      // 'X-Localization': this.language
    })
  };

  return this.http.post<any>(
    `${environment.apiUrl}/users/files/${fileID}/saved`,null,
    httpOptions
  );
}

deleteFile(fileID:string){
  var token = this.auth.token;

  const httpOptions = {
    headers: new HttpHeaders({
      'Authorization': token != ''  ? `Bearer ${token}` : '',
      'Accept': 'application/json',
      // 'X-Localization': this.language
    })
  };

  return this.http.delete<any>(
    `${environment.apiUrl}/users/files/${fileID}/deleted`,
    httpOptions
  );
}

registerBidding(bidinID:String, biddingSession:String, name:string, email:string, custNumber:string, token:string) {
  let body = new FormData();
  body.append("name", name);
  body.append("email", email);
  // body.append("point", currentPoint);
  body.append("customer_number", custNumber);
  body.append("token", token);
  return this.http
    .post<any>(`${environment.apiUrl}/events/${environment.eventId}/virtualBiddings/${bidinID}/biddingSessions/${biddingSession}/biddingUsers`, body)
    .pipe(
      map((resData: any) => {
        return resData;
      })
      // tap(this.setUserData.bind(this))
    );
}

loginBidding(bidinID:string, biddingSession:string, code:string, token:string) {
  let body = new FormData();
  body.append("code", code);
  body.append("token", token);
  return this.http
    .post<any>(`${environment.apiUrl}/events/${environment.eventId}/virtualBiddings/${bidinID}/biddingSessions/${biddingSession}/loginBiddingUsers`, body)
    .pipe(
      map((resData: any) => {
        return resData;
      })
      // tap(this.setUserData.bind(this))
    );
}

chatbotLogs(id:any){
  var token = this.auth.token;

  let body = new FormData();
  body.append('chat_bot_id', id);
  const httpOptions = {
    headers: new HttpHeaders({
      'Authorization': `Bearer ${token}`
    })
  };
  return this.http.post<any>(
    `${environment.apiUrl}/chatBots/logs`,
    body,
    httpOptions
  );
}

getGateActivityByKanwil(kanwilID:any) {

  var httpOptions = {
    headers: new HttpHeaders({
      Authorization: ``,
    }),
  };

  return this.http.get<any>(
    `${environment.apiUrl}/events/${environment.eventId}/offlineActivity/${kanwilID}/log`,
    httpOptions
  );
}

getSearchByKeyword(keyword: string) {
  return this.http.get<any>(
    `${environment.apiUrl}/search_keyword?keyword=${keyword}`
  );
}

getNewsList(page:number, limit:number, typeFilter:string) {

  return this.http.get<any>(
    `${environment.apiUrl}/events/${environment.eventId}/news?page=${page}&limit=${limit}${typeFilter != '' ? `&type=${typeFilter}` : ''}`,
  );

}

}
